import { Component, Input, OnInit } from '@angular/core';
import { pageLoginService } from "../../../services/page-login/page-login.service";
import { environment } from "../../../../environments/environment";
import { EnvironmentService } from 'src/app/services/environment.service';

@Component({
  selector: 'app-page-login-img',
  templateUrl: './page-login-img.component.html',
  styleUrls: ['./page-login-img.component.scss']
})
export class PageLoginImgComponent implements OnInit {
  @Input() pageLogin: any;
  @Input() imageSrc: string;
  @Input() isVisible: boolean;

  defaultPageLogin: any = {
    title: '',
    content: '',
    description: '',
    pageLoginReseauSocials: []
  };


  constructor(private pageLoginService: pageLoginService, private readonly environmentService: EnvironmentService) {}

  ngOnInit(): void {
    this.loadDataLoginPage(this.environmentService.get().companySiteIdentifier);
  }



  loadDataLoginPage(COMPANY_SITE_IDENTIFIER): void {
    this.pageLoginService.getPageLogin(COMPANY_SITE_IDENTIFIER).subscribe(
      (data: any) => {
        this.pageLogin = data;

        if (data.content == null) {
          this.pageLogin.content = '';
        }
        if (data.file) {
          this.imageSrc = "data:image/png;base64," + data.file;
        }
      },
      (error: any) => {
        this.pageLogin=this.defaultPageLogin;
        console.error('getPageLogin Error', error);
      }
    );
  }
}
